import Layout from "../../containers/Layout";
import VideoTemplate from "../VideoTemplate/VideoTemplate";
import Seo from "../Seo/Seo";

const mainTextContent = `
🚀 Boost your Spanish with our free Telegram channel!  

📚 You'll get daily exercises and crystal-clear explanations.  

👉 Click the button below to join — or scan the QR code if you prefer!
`;

const GetStarted = () => {
  return (
    <Layout mt={35}>
      <Seo
        title="Get Started Learning Spanish"
        description="Join our free Telegram channel for daily Spanish exercises and clear explanations — the easiest way to start practicing today."
        path="/get-started"
      />
      <VideoTemplate
        imageUrl="/images/Telegram-channels-SWA.png"
        imageAlt="Join our free Telegram channel for daily Spanish practice"
        mainTitle="GET THE BEST ON YOUR PHONE"
        subTitle=""
        mainText={mainTextContent}
        buttonLabel="Join Telegram Group"
        linkPath="https://t.me/+S78OquqBTZdmNGNk"
        showButton={true}
      />
    </Layout>
  );
};

export default GetStarted;
